import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, CircularProgress, Typography, useTheme } from '@material-ui/core';
import { getPerdasInsumos } from '../../../../../services/DashboardService';
import Chart from 'react-apexcharts';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import DateRangeIcon from '@material-ui/icons/DateRange';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import IconButton from '@material-ui/core/IconButton';


const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 20,
    minHeight: '100%'
  },
  chartContainer: {
    minHeight: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GraficoPerdasInsumos = props => {
  const { className, ...rest } = props;
  const theme = useTheme();
  const PERIODO_ANUAL = 0;
  const PERIODO_MENSAL = 1;
  const PERIODO_SEMANAL = 2;
  const PERIODO_PERSONALIZADO = 3;
  const [perdasInsumos, setPerdasInsumos] = useState([]);
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [labels, setLabels] = useState([]);
  const [valores, setValores] = useState([]);
  const [refreshState, setRefreshState] = useState(new Date());
  let [periodo, setPeriodo] = React.useState(PERIODO_SEMANAL);
  let [dataInicialPersonalizada, setDataInicialPersonalizada] = useState(null);
  let [dataFinalPersonalizada, setDataFinalPersonalizada] = useState(null);

  const classes = useStyles();

  useEffect(() => {
    try {
      getDados();
    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      const data = new Date();
      let dataInicial = moment.utc(data).startOf('week').format('YYYY-MM-DD');
      let dataFinal = moment.utc(data).endOf('week').format('YYYY-MM-DD');
      if (periodo === PERIODO_MENSAL) {
        dataInicial = moment.utc(data).startOf('month').format('YYYY-MM-DD');
        dataFinal = moment.utc(data).endOf('month').format('YYYY-MM-DD');
      }
      if (periodo === PERIODO_ANUAL) {
        dataInicial = moment.utc(data).startOf('year').format('YYYY-MM-DD');
        dataFinal = moment.utc(data).endOf('year').format('YYYY-MM-DD');
      }
      if (periodo === PERIODO_PERSONALIZADO) {
        if (dataInicialPersonalizada && dataFinalPersonalizada && moment.isDate(dataInicialPersonalizada) && moment.isDate(dataFinalPersonalizada)) {
          dataInicial = moment.utc(dataInicialPersonalizada).format('YYYY-MM-DD');
          dataFinal = moment.utc(dataFinalPersonalizada).format('YYYY-MM-DD');
        }
        else {
          return;
        }

      }
      setMostrarProgress(true);
      let dados = await getPerdasInsumos(dataInicial, dataFinal);
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setPerdasInsumos(dados.result);
        let novasLabels = [];
        let novosValores = [];
        dados.result.map(perdaInsumo => {
          if (perdaInsumo.totalPerdas && perdaInsumo.totalPerdas !== 0) {
            novasLabels.push([perdaInsumo.descricao]);
            novosValores.push(perdaInsumo.totalPerdas < 0 ? ( perdaInsumo.totalPerdas * -1 ) : perdaInsumo.totalPerdas );
          }

        });
        setLabels(novasLabels);
        setValores(novosValores);

      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  const aoModificarPeriodo = async (event, novoPeriodo) => {
    periodo = novoPeriodo;
    setPeriodo(novoPeriodo);
    if (novoPeriodo === PERIODO_PERSONALIZADO) {
      setValores([]);
      setLabels([]);
    }
    await getDados();
  };

  const aoModificarDataInicialPersonalizada = async date => {
    dataInicialPersonalizada = date;
    setDataInicialPersonalizada(date);
    if (dataInicialPersonalizada && dataFinalPersonalizada && moment.isDate(dataInicialPersonalizada) && moment.isDate(dataFinalPersonalizada)) {
      await getDados();
    }
  };

  const aoModificarDataFinalPersonalizada = async date => {
    dataFinalPersonalizada = date;
    setDataFinalPersonalizada(date);
    if (dataInicialPersonalizada && dataFinalPersonalizada && moment.isDate(dataInicialPersonalizada) && moment.isDate(dataFinalPersonalizada)) {
      await getDados();
    }
  };

  async function alternarParaPeriodosDeterminados(event) {
    event.preventDefault();
    periodo = PERIODO_SEMANAL;
    setPeriodo(PERIODO_SEMANAL);
    setDataInicialPersonalizada(null);
    setDataFinalPersonalizada(null);
    setRefreshState(new Date());
    await getDados();
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
    >
      <CardHeader
        title="Perdas de insumos"
        action={
          periodo === PERIODO_PERSONALIZADO ?
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={5}
              xs={5}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin="dense"
                    inputVariant="outlined"
                    orientation="landscape"
                    id="dataInicialPersonalizada"
                    label="Data inicial"
                    format="dd/MM/yyyy"
                    size='small'
                    value={dataInicialPersonalizada}
                    onChange={aoModificarDataInicialPersonalizada}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    InputAdornmentProps={{ position: "end" }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid
              item
              md={5}
              xs={5}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin="dense"
                    inputVariant="outlined"
                    orientation="landscape"
                    id="dataFinalPersonalizada"
                    label="Data final"
                    format="dd/MM/yyyy"
                    size='small'
                    value={dataFinalPersonalizada}
                    onChange={aoModificarDataFinalPersonalizada}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    InputAdornmentProps={{ position: "end" }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid
              item
              md={1}
              xs={1}
            >
              <IconButton
                aria-label="delete"
                className={classes.margin}
                size="medium"
                onClick={ e => alternarParaPeriodosDeterminados(e) }
              >
                <FormatListBulletedIcon fontSize="inherit" />
              </IconButton>
            </Grid>
          </Grid>
            :
          <ToggleButtonGroup
              value={periodo}
              exclusive
              onChange={aoModificarPeriodo}
              aria-label="text alignment"
              size={'small'}
            >
              <ToggleButton
                value={PERIODO_SEMANAL}
                aria-label="right aligned"
                style={{
                  borderTopLeftRadius: 25,
                  borderBottomLeftRadius: 25,
                }}
              >
                SEMANAL
              </ToggleButton>
              <ToggleButton
                value="center"
                aria-label="centered"
                value={PERIODO_MENSAL}
              >
                MENSAL
              </ToggleButton>
              <ToggleButton
                value={PERIODO_ANUAL}
                aria-label="left aligned"
              >
                ANUAL
              </ToggleButton>
              <ToggleButton
                value={PERIODO_PERSONALIZADO}
                style={{
                  borderTopRightRadius: 25,
                  borderBottomRightRadius: 25,
                }}
              >
                <DateRangeIcon
                  style={{
                    marginLeft: 5,
                    marginRight: 5
                  }}
                />
              </ToggleButton>
            </ToggleButtonGroup>
        }
      />
      <CardContent
      >
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <div className={classes.chartContainer}>
                  <CircularProgress
                  />
                </div>
              </Grid>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <div className={classes.chartContainer}>
                {
                  valores && valores.length > 0 ?
                    <Chart
                      options={{
                        chart: {
                          height: 350,
                          type: 'bar',
                          toolbar: {
                            show: false
                          },
                        },
                        colors: [
                          theme.palette.info.main,
                          theme.palette.warning.main,
                          theme.palette.success.main,
                          theme.palette.error.main,
                          theme.palette.action.active,
                          theme.palette.primary.main
                        ],
                        plotOptions: {
                          bar: {
                            columnWidth: '35%',
                            distributed: true,
                          }
                        },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val;
                          },
                          style: {
                            fontSize: '12px',
                            colors: ["#FFFFFF"]
                          }
                        },
                        legend: {
                          show: false
                        },
                        yaxis: {
                          title: {
                            text: 'Quantidade'
                          },
                        },
                        xaxis: {
                          categories: labels,
                          labels: {
                            style: {
                              fontSize: '12px'
                            }
                          },
                        }
                      }}
                      type={'bar'}
                      series={[{
                        name: 'Quantidade',
                        data: valores
                      }]}
                      height={400}
                    />
                    :
                    <Grid
                      container
                    >
                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{
                          display: 'flex',
                          justifyContent: 'center'
                        }}
                      >
                        <img
                          height={'170px'}
                          width={'220px'}
                          alt="Logo"
                          src={"/images/erroGeral.png"}
                          style={{
                            marginTop: 10,
                            marginBottom: 10
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        md={12}
                        xs={12}
                        style={{
                          display: 'flex',
                          justifyContent: 'center'
                        }}
                      >
                        <Typography className={classes.title} variant="h4" color="textSecondary" gutterBottom id='tituloTabelaEstoqueMovimentacao'>
                          { 'Não há informações para perdas de insumos.' }
                        </Typography>
                      </Grid>
                    </Grid>
                }
              </div>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

GraficoPerdasInsumos.propTypes = {
  className: PropTypes.string
};

export default GraficoPerdasInsumos;
